import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      backgroundColor: "var(--damage-explainer-background)",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      paddingX: "baseUnit.mobile3",
      paddingTop: "baseUnit.mobile3",
      paddingBottom: "baseUnit.mobile4",
      tabletLandscape: {
        paddingTop: "baseUnit.mobile4",
      },
    }),
  contentWrapper: () =>
    css({
      width: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
    }),
  toggleRow: () =>
    css({
      display: "flex",
      justifyContent: "flex-start",
      width: "100%",
      tabletLandscape: {
        justifyContent: "flex-end",
      },
    }),
  imageContainer: () =>
    css({
      backgroundColor: "babyBlue",
      width: "100%",
      borderRadius: "baseUnit.mobile2",
      padding: "12px",
      boxShadow: "damageExplainerMobile",
      position: "relative",
      tabletLandscape: {
        borderRadius: "baseUnit.mobile5",
        padding: "baseUnit.mobile3",
        boxShadow: "damageExplainerDesktop",
      },
    }),
  imageWrapper: () =>
    css({
      width: "var(--mobile-image-width)",
      backgroundColor: "white",
      borderRadius: "baseUnit.mobile1",
      overflow: "hidden",
      tabletLandscape: {
        borderRadius: "20px",
        width: "var(--desktop-image-width)",
      },
      "& picture": {
        maxWidth: "none",
      },
    }),
  showOnMobile: () =>
    css({
      display: "block",
      tabletLandscape: {
        display: "none",
      },
    }),
  showOnDesktop: () =>
    css({
      display: "none",
      tabletLandscape: {
        display: "block",
      },
    }),
  hotSpotsWrapper: (showHotSpots: boolean) =>
    css({
      position: "absolute",
      top: "12px",
      right: "12px",
      bottom: "12px",
      left: "12px",
      opacity: 0,
      animation: showHotSpots ? "visibilityFade 0.6s ease forwards" : "none",
      tabletLandscape: {
        top: "baseUnit.mobile3",
        right: "baseUnit.mobile3",
        bottom: "baseUnit.mobile3",
        left: "baseUnit.mobile3",
      },
    }),
};
